/* eslint-disable import/prefer-default-export */

export const offersEndpoint = state => `${state.config.apiUrl}/v1/offers`;



// WEBPACK FOOTER //
// ./src/services/offers/selectors.js